import { useState, useMemo } from 'react'
import { CategoriesContainer, Category, CategoryToggle } from './styles'
import { trackInternalEvent } from '@rio/tracking'
import PropTypes from 'prop-types'

const VISIBLE_CATEGORIES = 7

function TemplatesCategories({
  categories,
  activeCategory,
  setActiveCategory,
  documentType,
  i18n,
  atpStickyCategories = false,
}) {
  const [isToggled, setToggled] = useState(false)

  const displayedCategories = useMemo(() => {
    let result = [...categories].sort((a, b) => {
      if (a.slug === 'all') return -1
      if (a.popularCategory === b.popularCategory) return 0
      return a.popularCategory ? -1 : 1
    })
    if (!isToggled) {
      result = result.slice(0, VISIBLE_CATEGORIES)
    }
    return result
  }, [categories, isToggled])

  const toggle = () => {
    setToggled(prev => {
      trackInternalEvent(`click_${prev ? 'less' : 'more'}_categories`, {
        label: 'funnel',
      })
      return !prev
    })
  }

  const changeCategory = category => {
    trackInternalEvent(`change_${documentType}_templates_category`, {
      tab: category.slug,
      label: 'funnel',
      stickyCategory: atpStickyCategories ? 'yes' : 'no',
    })
    setActiveCategory(category)
  }

  return (
    <CategoriesContainer>
      {displayedCategories.map(category => {
        const isActive = category.slug === activeCategory?.slug
        return (
          <Category key={category.id} isActive={isActive} onClick={() => changeCategory(category)}>
            {category.name}
          </Category>
        )
      })}
      {categories.length > VISIBLE_CATEGORIES && (
        <CategoryToggle onClick={toggle}>
          {isToggled ? i18n.t('builder.sign_up.see_less') : i18n.t('builder.sign_up.see_more')}
        </CategoryToggle>
      )}
    </CategoriesContainer>
  )
}

TemplatesCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  setActiveCategory: PropTypes.func.isRequired,
  activeCategory: PropTypes.object,
  documentType: PropTypes.string,
  i18n: PropTypes.object,
  atpStickyCategories: PropTypes.bool,
}

export default TemplatesCategories
